/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotInSubjectId: core.serialization.ObjectSchema<serializers.NotInSubjectId.Raw, Truvity.NotInSubjectId> =
    core.serialization.object({
        values: core.serialization.list(core.serialization.string()),
    });

export declare namespace NotInSubjectId {
    export interface Raw {
        values: string[];
    }
}
